import ForgotPassword from "screens/Auth/forgot-password";
import Login from "screens/Auth/login";
import Register from "screens/Auth/register";
import SetPassword from "screens/Auth/set-password";
import VerifyEmail from "screens/Auth/verify-email";

const authRoutes = [
	{
		type: "collapse",
		name: "Login",
		key: "login",
		route: "/login",
		component: <Login />,
		noCollapse: true,
	},
	{
		type: "collapse",
		name: "Verify Email",
		key: "verify-email",
		route: "/verify-email",
		component: <VerifyEmail />,
		noCollapse: true,
	},
	{
		type: "collapse",
		name: "Forgot Password",
		key: "forgot-password",
		route: "/forgot-password",
		component: <ForgotPassword />,
		noCollapse: true,
	},
	{
		type: "collapse",
		name: "Set Password",
		key: "set-password",
		route: "/set-password",
		component: <SetPassword />,
		noCollapse: true,
	},
	// {
	// 	type: "collapse",
	// 	name: "Register",
	// 	key: "register",
	// 	route: "/register",
	// 	component: <Register />,
	// 	noCollapse: true,
	// },
];

export default authRoutes;
